'use client';

import classNames from 'classnames';
import styles from './FormSubmissionAnimation.module.css';

export const FormSubmissionAnimation = () => {
	return (
		<div
			className="fixed top-0 z-50 flex h-screen w-screen items-center justify-center bg-white"
			data-testid="FormSubmissionAnimation"
		>
			<div className="flex justify-center gap-2 text-center">
				<div
					className={classNames(
						'align-center flex w-full max-w-80 flex-col items-center gap-2 text-center',
					)}
				>
					<p className={classNames(styles['loading-text'])}>One Moment</p>

					<span
						className={classNames(
							styles['loading-bar'],
							`relative block h-px bg-gradient-to-r from-transparent via-royal-orange
							to-transparent`,
						)}
					></span>
				</div>
			</div>
		</div>
	);
};
